import React from 'react';
import "../../styles/sedg-cell/main.css";

const Main = () => {
  return (
    <section id="sedg-cell">
      <div className="container">
        <h2 className="my-heading text-center">
          Helping Everyone Learn: The SEDG Cell at CCSU Meerut
        </h2>
        <div className="content">
          <p><span>What is CCSU Doing to Help? </span></p>
          <p>
            Chaudhary Charan Singh University (CCSU) in Meerut wants every student to get a fair chance to study and
            grow, especially those who come from families that don’t have much money or support. To help, the
            university has created a special group called the SEDG Cell. This stands for Socio-Economically
            Disadvantaged Groups.
          </p>
          <p><span>Why Was the SEDG Cell Made? </span></p>
          <p>
            Some students face extra challenges because of where they come from or the problems they face at home.
            CCSU wants to make sure these students don’t feel left out. The SEDG Cell works to make things fair for
            everyone in school, and follows the rules made by the University Grants Commission (UGC).
          </p>
          <p><span>What Does the SEDG Cell Do? </span></p>
          <p>The SEDG Cell helps students in many ways: </p>
          <ul>
            <li><b>Involvement:</b> Makes sure all students can take part in studies, sports, clubs, and decisions.</li>
            <li><b>Learning Help:</b> Arranges workshops, training, and talks to help students build skills and confidence.</li>
            <li><b>Money Support:</b> Helps students find scholarships and other financial help.</li>
            <li><b>Fair Rules:</b> Suggests new ideas and rules to make education more equal for everyone.</li>
            <li><b>Grievance Support:</b> Listens and acts when a student feels they’ve been treated unfairly.</li>
          </ul>

          <p><span>Main Activities of the Cell </span></p>
          <ul>
            <li><b>Spreading Awareness:</b> Teaches students and staff why it’s important to treat everyone equally.</li>
            <li><b>Support and Mentoring:</b> Gives guidance and creates buddy systems for students who need extra help.</li>
            <li><b>Data Collection:</b> Keeps track of how students are doing and uses this information to improve support.</li>
            <li><b>Community Work:</b> Reaches out to families and schools to help more students join the university.</li>
            <li><b>Policy Checks:</b> Keeps an eye on university rules to make sure they help everyone fairly.</li>
          </ul>

          <p><span>How It Works</span></p>
          <p>The Cell finds students who need help through forms, surveys, and teacher recommendations.</p>
          <p>It solves problems students report within 30 days.</p>
          <p>It partners with government groups and NGOs to offer more support.</p>
          <p>It reviews its work regularly and writes reports for the university and UGC.</p>

          <div className="more-boxes">
            <div className="box-faculty">
              <div className="image">
                <img src="../assets/images/administration/Dinesh Kumar.png" alt="Prof. Dinesh Kumar" />
              </div>
              <div className="content">
                <h1>Prof. Dinesh Kumar</h1>
                <p>Chief Warden</p>
                <a href="#" className="pdf-link" target="_blank" rel="noopener noreferrer">View resume</a>
              </div>
            </div>

            <div className="box-faculty">
              <div className="image">
                <img src="../assets/images/administration/committee/AV-kaur.jpg" alt="Prof. Ajay Vijay Kaur" />
              </div>
              <div className="content">
                <h1>Prof. Ajay Vijay Kaur</h1>
                <p>Department of History</p>
                <a href="#" className="pdf-link" target="_blank" rel="noopener noreferrer">View resume</a>
              </div>
            </div>

            <div className="box-faculty">
              <div className="image">
                <img src="../assets/images/administration/committee/alpana-aggarwal.jpg" alt="Prof. Alpana Agrawal" />
              </div>
              <div className="content">
                <h1>Prof. Alpana Agrawal</h1>
                <p>Department of Psychology</p>
                <a href="#" className="pdf-link" target="_blank" rel="noopener noreferrer">View resume</a>
              </div>
            </div>

            <div className="box-faculty">
              <div className="image">
                <img src="../assets/images/administration/committee/mukesh.jpg" alt="Prof. Mukesh Kumar Sharma" />
              </div>
              <div className="content">
                <h1>Prof. Mukesh Kumar Sharma</h1>
                <p>Department of Mathematics</p>
                <a href="#" className="pdf-link" target="_blank" rel="noopener noreferrer">View resume</a>
              </div>
            </div>

            <div className="box-faculty">
              <div className="image">
                <img src="../assets/images/dummy.webp" alt="Dr. Vijeta Gautam" />
              </div>
              <div className="content">
                <h1>Dr. Vijeta Gautam</h1>
                <p>Department of English</p>
                <a href="#" className="pdf-link" target="_blank" rel="noopener noreferrer">View resume</a>
              </div>
            </div>

            <div className="box-faculty">
              <div className="image">
                <img src="../assets/images/dummy.webp" alt="Dr. Anshu Chaudhary" />
              </div>
              <div className="content">
                <h1>Dr. Anshu Chaudhary</h1>
                <p>Department of Zoology</p>
                <a href="#" className="pdf-link" target="_blank" rel="noopener noreferrer">View resume</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Main;
